import {
  ButtonLink,
  NoResultsRow,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@razz-team/ui-web';
import { ApiStandingOrder } from '../../../openapi';
import { useTranslation } from 'react-i18next';
import { formatAccountNumberByNetworkForDisplay } from '@razz-team/utils';
import { StandingOrderStatusBadge } from './StandingOrderStatusBadge';
import { StandingOrderAmount } from './StandingOrderAmount';

export function StandingOrdersTable({
  orders,
  isLoading,
  error,
}: {
  orders: ApiStandingOrder[] | undefined;
  isLoading: boolean;
  error: Error | null;
}) {
  const { t } = useTranslation();

  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell width="10%">{t('Status')}</TableCell>
          <TableCell width="10%">{t('Network')}</TableCell>
          <TableCell width="50%">{t('From')}</TableCell>
          <TableCell width="30%">{t('Predicate')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <>
            <TableRow>
              <TableCell variant="subhead" colSpan={3}>
                <Skeleton variant="text" width={100} />
              </TableCell>
            </TableRow>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <TableRow key={rowIndex} sx={{ height: '40px' }}>
                {Array.from({ length: 3 }).map((__, cellIndex) => (
                  <TableCell key={cellIndex}>
                    <Skeleton variant="text" width={'50%'} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </>
        ) : error ? null : orders?.length === 0 ? (
          <NoResultsRow colSpan={3} text={t('No standing orders created yet')} />
        ) : (
          orders?.map((order) => (
            <TableRow key={order.id}>
              <TableCell>
                <StandingOrderStatusBadge status={order.status} />
              </TableCell>
              <TableCell>{order.predicate.origin.networkId}</TableCell>
              <TableCell>
                <ButtonLink
                  to="/account/standing-orders/$orderId/$step"
                  params={{ orderId: order.id, step: 'destinations' }}
                  variant="text"
                >
                  {formatAccountNumberByNetworkForDisplay(order.predicate.origin)}
                </ButtonLink>
              </TableCell>
              <TableCell>
                <StandingOrderAmount amount={order.predicate.amount} />
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
